import PropTypes from 'prop-types';
import './DropdownMenu.scss';

export const DropdownMenu = (props) => {
  const {
    menuData,
    defaultValue,
    chosenValue,
    isMenuOpen,
    menuItemClickedHandler,
    singleColumn,
    hideDefaultItem,
    disableDefaultItem,
    extendClass = '',
  } = props;

  const isLongMenu = singleColumn && menuData.length > 10;
  const longMenuClass = isLongMenu ? 'is-long-menu' : '';
  const menuOpenClass = isMenuOpen ? 'open' : '';

  const mainUlClasses = [
    'dropdown-with-menu__menu',
    menuOpenClass,
    extendClass,
    longMenuClass,
  ].join(' ');
  const menuSectionClasses = ['menu-section', singleColumn && 'menu-section--single-column'].join(
    ' '
  );

  const defaultMenuItemClasses = [
    'menu-item default-item',
    defaultValue === chosenValue ? 'menu-item__underline' : '',
  ].join(' ');

  const handleDefaultItemActive = () => !disableDefaultItem && menuItemClickedHandler({ itemName: defaultValue });

  const defaultValueMenuItem = (
    <li className={menuSectionClasses} data-testid="default-item">
      <ul className="menu-section-list">
        <li
          role="menuitem"
          aria-disabled={disableDefaultItem}
          onClick={handleDefaultItemActive}
          onKeyDown={(e) => e.key === 'Enter' && handleDefaultItemActive()}
          className={defaultMenuItemClasses}
        >
          {defaultValue}
        </li>
      </ul>
    </li>
  );

  const hasNestedArrays = menuData?.length && menuData[0].constructor === Array;
  const menuDataAsArray = hasNestedArrays ? menuData : [menuData];

  const allOtherMenuItems = menuDataAsArray?.map((menuSection, index) => (
    <li className={menuSectionClasses} key={index}>
      <ul className="menu-section-list">
        {menuSection.map((menuItem) => {
          const { key, name } = menuItem;
          const menuItemClasses = [
            'menu-item',
            name === chosenValue ? 'menu-item__underline' : '',
          ].join(' ');
          const handleActive = () => menuItemClickedHandler({ itemName: name, itemId: key });

          return (
            <li
              role="menuitem"
              onClick={handleActive}
              onKeyDown={(e) => e.key === 'Enter' && handleActive()}
              className={menuItemClasses}
              key={key}
            >
              {name}
            </li>
          );
        })}
      </ul>
    </li>
  ));

  return (
    <ul className={mainUlClasses} data-testid="dropdown-menu">
      {!hideDefaultItem && defaultValueMenuItem}
      {allOtherMenuItems}
    </ul>
  );
};

DropdownMenu.propTypes = {
  singleColumn: PropTypes.bool,
  extendClass: PropTypes.string,
  menuData: PropTypes.array,
  anchorEl: PropTypes.object,
  defaultValue: PropTypes.string,
  chosenValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isMenuOpen: PropTypes.bool,
  hideDefaultItem: PropTypes.bool,
  disableDefaultItem: PropTypes.bool,
  menuItemClickedHandler: PropTypes.func,
};
